/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { z } from 'zod'
import { withValidate } from 'lib/zod-validate'

export const OfferBasicSchema = withValidate(
    z.preprocess(
        (input) => {
            if (input && typeof input === 'object') {
                const asAny = input as any
                // Support both `children` and legacy `childrens` field names
                if (asAny.childrens !== undefined && asAny.children === undefined) {
                    asAny.children = asAny.childrens
                }
            }
            return input
        },
        z.object({
            name: z.string().trim().optional().nullable(),
            date: z.string().trim().min(1, 'Date is required'),
            valid_until: z.string().trim().min(1, 'Valid until is required'),
            adults: z
                .number({
                    message: 'Adults must be a number',
                })
                .min(0, 'Adults must not be negative'),
            children: z
                .number({
                    message: 'Children must be a number',
                })
                .min(0, 'Children must not be negative'),
            company_id: z.number({ message: 'Company is required' }).optional().nullable(),
            contact_id: z.number().optional().nullable(),
            probability: z
                .number({
                    message: 'Probability must be a number',
                })
                .min(0, 'Probability must be between 0 and 100')
                .max(100, 'Probability must be between 0 and 100')
                .nullable()
                .optional(),
            duration_minutes: z
                .number({
                    message: 'Duration must be a number',
                })
                .min(0)
                .nullable()
                .optional(),
        })
    )
)

export type OfferBasicInputs = z.infer<typeof OfferBasicSchema>
